// extracted by mini-css-extract-plugin
export var locationCard = "_oy-0";